// Module
var code = "<md-content flex layout=\"column\" layout-fill class=\"bg-white\" ng-include=\"'app/mobile/modules/main/menu/menu.html'\"> </md-content> ";
// Exports
module.exports = code;